// extracted by mini-css-extract-plugin
module.exports = {"tk_ChatButton":"ChatButton_tk_ChatButton__-Mox-"};